module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('b', [_vm._v("Contents")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii"
    }
  })]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border-collapse": "collapse"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "60%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Dedication"
    }
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Glossary"
    }
  }, [_vm._v("Glossary")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Preface"
    }
  }, [_vm._v("Preface")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_vm._v("Chapter 1:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_c('b', [_vm._v("The Early Camps, 1939-1940:")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec_1"
    }
  }, [_vm._v("Oflag X (Itzehoe) September-October 1939")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec_2"
    }
  }, [_vm._v("Oflag IVC (Colditz) June 1940-April 1945")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#sec_3"
    }
  }, [_vm._v("Oflag IXA/H (Spangenberg) October 1939-April 1942")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02"
    }
  }, [_vm._v("Chapter 2:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter02"
    }
  }, [_c('b', [_vm._v("Dulag Luft:")]), _vm._v(" December 1939-April 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Stalag VIIIB (Lamsdorf):")]), _vm._v(" May 1940-January 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Stalag Luft I (Barth):")]), _vm._v(" June 1940-May 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Wehrmacht Camps, 1941:")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#sec_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag VIIC (Laufen) July 1941-September 1941")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#sec_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag XC (Lübeck) July 1941-October 1941")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#sec_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag VIB (Warburg) October 1941-September 1942")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#sec_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IXC (Bad Sulza) July 1941-May 1942")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#sec_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IIIE (Kirchhain) July 1941-May 1942")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05#sec_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag VIIA (Moosburg) December 1941-September 1942")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Stalag Luft III (Sagan):")]), _vm._v(" March 1942-January 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Wehrmacht Camps, 1942-1943:")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#sec_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag 383 (Hohenfels) September 1942-April 1945")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#sec_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oflag XXIB (Schubin) October 1942-May 1943")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07#sec_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IVB (Mühlberg) June 1943-May 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Stalag Luft VI (Heydekrug):")]), _vm._v(" June 1943-July 1944")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Stalag Luft IV (Gross Tychow):")]), _vm._v(" July 1944-February 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Stalag 357 (Thorn and Oerbke); Stalag XIB (Fallingbostel):")]), _vm._v(" July 1944-April 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Stalag Luft VII (Bankau):")]), _vm._v(" June 1944-January 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Last Camps:")]), _vm._v(" Marlag und Milag Nord February 1945-April 1945")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#sec_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag IIIA (Luckenwalde) January-May 1945")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#sec_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag XIIID (Langwasser-Nürnberg) January-April 1945")]), _vm._v("; "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#sec_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stalag VIIA (Moosburg) January-April 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Operation Exodus:")]), _vm._v(" 1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Wounded:")]), _vm._v(" 1939-1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Repatriations:")]), _vm._v(" 1943-1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Traitors and Collaborators:")]), _vm._v(" 1940-1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("War Crimes, 1939-1944")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("War Crimes, 1945")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Introduction to the List of RAF Bomber Command Prisoners-of-War")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Plates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Gallery")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Appendix_I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The List of RAF Bomber Command PoWs")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Numbering System and Location of German PoW Camps")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Appendix_III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix III:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Appendix_III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Periods of occupation of German PoW camps by RAF PoWs, 1939-1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Appendix_IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IV:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Appendix_IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Bomber Command PoW losses, 1939-1945: by month")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Appendix_V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix V:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Appendix_V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Bomber Command PoW losses, 1939-1945: by aircraft type")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Appendix_VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VI:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Appendix_VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Bomber Command PoW losses, 1939-1945: by squadron")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Appendix_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VII:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Appendix_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Bomber Command PoW losses, 1939-1945: by rank")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Appendix_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VIII:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Appendix_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Bomber Command PoW losses, 1939-1945: by nationality")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IX:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Appendix_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Bomber Command PoW losses, 1939-1945: by target")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Appendix_X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix X:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Appendix_X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF escapers, 1941-1945")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Appendix_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XI:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Appendix_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comparative British and German Ranks")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Appendix_XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XII:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Appendix_XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nazi Propaganda Campaign against Airmen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Appendix_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XIII:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Appendix_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nazi Party Security Forces")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Appendix_XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XIV:")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Appendix_XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Cross Parcels")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Plans_PoW",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plans of some PoW camps used by RAF")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Notes_to_Chapters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes to Chapters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 69
// module chunks = 0